//PACKAGES
import { useLocation, useNavigate } from "react-router-dom";

//CONSTANTS & ASSETS
import { STRING, STRINGS } from "../constant";
import { IMAGES, SVG_IMAGES } from "../assets";

//COMPONENTS
import { Header, LAView, LAText} from "../components";
import HTMLContent from "../components/HTMLContent";
import ExplanationComponent from "../components/ExplanationComponent";
import AnswerMessage from "../components/AnswerMessage";
import CommonHeader from "../components/common/CommonHeader";
import QuestionOptions from "../components/common/QuestionOptions";
import QuestionsProgress from "../components/questions/QuestionsProgress";
import NavBar from "../components/NavBar";
import RelatedStudyArticles from "../components/common/RelatedStudyArticles";

//PACKAGES
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import IconTint from "react-icon-tint";
import { AuthContext } from "../context/AuthProvider";
import { useContext, useEffect, useState } from "react";
import { BundleContext } from "../context/BundleProvider";
import { GET_COMMUNITY_SINGLE_QUESTION_DETAILS } from "../api/community";
import { GET_APP_DOMAIN_LIST } from "../../app_constant";
// import { GET_QUESTION_FROM_ID } from "../../content";
import OptionButton from "../components/question/OptionButton";
import BackArrowIcon from "../components/BackArrowIcon";

import { ThemeContext } from "../context/ThemeProvider";
import BookmarkIcons from "../components/BookmarkIcons";
import CommunityPopup from "./quickSet/CommunityPopup";
import TabFooter from "../components/TabFooter";
import { GET_QUESTION_FROM_ID } from "../api/test";
import { TestReviewCommunity } from "../components/common/CommonModals";

function QuestionReview({ 
  isOnboarding = false
}) {
  const { state } = useLocation();
  const { theme, currentTheme } = useContext(ThemeContext);
  const title = state?.title;
  const item = state?.item;
  const questions = state?.questions;
  const lastReadinessScore = state?.lastReadinessScore;
  
  console.log("QuestionReview state:", state);
  console.log("QuestionReview questions:", questions);
  

  const {
    profile,
    questionsList,
    addQuestionToBookmark,
    removeQuestionFromBookmark,
    isVisibleCommunity,
  } = useContext(AuthContext);
  const navigation = useNavigate();
  const { selectedCertificate: contextSelectedCertificate } = useContext(BundleContext);
  
  // Use state if available, otherwise fall back to context
  const selectedCertificate = state?.selectedCertificate || contextSelectedCertificate;
  

  const [isLoadingCommunityData, setLoadingCommunityData] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [quickSetState, setQuickSetState] = useState({
    selectedOpion: null,
  });
  const [currentIndex, setCurrentIndex] = useState(0);
  const [communityQuestion, setCommunityQuestion] = useState(null);
  const [isCommunityPopup, setCommunityPopup] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [savedAnswers, setSavedAnswers] = useState([]);
  const OPTIONS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

  const styles = {
    questionCard: {
      background: theme.dashboard.card.background,
      border: `1px solid ${theme.dashboard.card.border}`,
      borderRadius: '1rem',
      boxShadow: theme.dashboard.card.shadow,
      marginBottom: '2rem',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
    questionContent: {
      padding: '2rem',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },
    questionText: {
      marginBottom: '2rem',
      color: theme.text.primary,
      fontSize: '1.125rem',
      lineHeight: '1.7',
    },
    optionsGrid: {
      display: 'grid',
      gap: '1rem',
      gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
      alignItems: 'stretch',
    },
  }
  useEffect(() => {
    if (isVisibleCommunity) {
      setCommunityQuestion(null);

      if (questions?.length > 0 && !isNaN(currentIndex)) {
        const question = questions[currentIndex];
        getCommunityQuestion(question.question_id);
      }
    }
  }, [currentIndex, isVisibleCommunity]);

  function getCurrentQuestion() {
    if (questions?.length > 0 && !isNaN(currentIndex)) {
      const id = questions[currentIndex].question_id;
      return GET_QUESTION_FROM_ID(questionsList, id);
    }

    return null;
  }

  function getTopicId() {
    if (!questions || questions.length <= currentIndex) {
      return "";
    }
    const APP_DOMAIN_LIST = GET_APP_DOMAIN_LIST(selectedCertificate);
    const array = APP_DOMAIN_LIST?.find(
      (item) => item?.id == questions[currentIndex]?.topic_id
    );
    return array?.domain_name ?? "";
  }

  function onBack() {
    navigation(-1);
    // props.navigation.goBack();
  }

  function onPrevious() {
    // scrollRef.current.scrollTo({ x: 0, y: 0, animated: false });
    setCurrentIndex((state) => {
      return state == 0 ? 0 : state - 1;
    });
  }

  function onNext() {
    // scrollRef.current.scrollTo({ x: 0, y: 0, animated: false });
    setCurrentIndex((state) => {
      return state == questions?.length - 1 ? 0 : state + 1;
    });
  }

  function onBookmark() {
    if (questions?.length > currentIndex) {
      const question = questions[currentIndex];
      if (isBookmark) {
        removeQuestionFromBookmark(question.question_id);
      } else {
        addQuestionToBookmark(question.question_id);
      }
    }
  }

  function checkBookmark() {
    if (questions?.length > currentIndex) {
      const question = questions[currentIndex];
      return (
        profile?.question_bookmarks?.includes(question.question_id) ?? false
      );
    }

    return false;
  }

  async function getCommunityQuestion(id) {
    try {
      setLoadingCommunityData(true);
      const result = await GET_COMMUNITY_SINGLE_QUESTION_DETAILS(id);
      setLoadingCommunityData(false);
      if (result.data) {
        setCommunityQuestion(result.data);
      } else {
        setCommunityQuestion(null);
      }
    } catch (error) {
      console.error(error);
      setCommunityQuestion(null);
    }
  }

  
  function getCommunityQuestionPercentage() {
    if (communityQuestion && true) {
      const percentage =
        (communityQuestion?.times_answered_correct /
          communityQuestion?.times_answered) *
        100;
      if (isNaN(percentage) || !isFinite(percentage) || percentage < 50) {
        return {
          color: theme?.primary?.red?.[500],
          percentage: 0,
          message: STRINGS.community_popup_desc_less_50,
          level: 'hard'
        };
      } else if (percentage < 80) {
        return {
          color: theme?.primary?.yellow?.[500],
          percentage: 0,
          message: STRINGS.community_popup_desc_less_80,
          level: 'medium'
        };
      } else {
        return {
          color: theme?.primary?.green?.[500],
          percentage: 0,
          message: STRINGS.community_popup_desc_less_100,
          level: 'easy'
        };
      }
    }

    return {
      color: theme?.primary?.red?.[500],
      percentage: 0,
      message: STRINGS.community_popup_desc_less_50,
      level: 'hard'
    };
  }

  function onPressCommunity() {
    setCommunityPopup(true);
  }

  const isBookmark = checkBookmark();
  const currentItem = getCurrentQuestion();
  const topic = getTopicId();
  const communitySettings = getCommunityQuestionPercentage();

  return (
    <div className="min-h-screen transition-colors duration-300" 
         style={{ background: theme?.background?.main }}>
      
      {!isOnboarding && (
        <CommonHeader
          title={title}
          subtitle="Review your test"
          showBackButton={true}
          onBack={() => navigation("/testReview", { state: { historyData: item, canGoBackKey: false, lastReadinessScore } })}
          theme={theme}
        />
      )}
          
        <QuestionsProgress
          currentIndex={currentIndex}
          totalQuestions={questions?.length ?? 0}
          isBookmarked={isBookmark}
          communityStats={getCommunityQuestionPercentage()}
          onBookmark={onBookmark}
          onShowCommunity={onPressCommunity}
          theme={theme}
          hideBookmark={isOnboarding}
        />
      

        {currentItem && questions?.length > 0 ? (
          <div style={styles.questionCard}>
            <div style={styles.questionContent}>
            <div style={styles.questionText}>
            <HTMLContent
              index={currentItem?.question?.id}
              htmlContent={currentItem?.question?.question}
              style={{ 
            fontSize: '1.125rem',
            lineHeight: '1.75',
            color: theme?.text?.primary,
          }}
            />
            </div>
            
            <div style={styles.optionsGrid}>
            <div className="grid gap-4 grid-cols-1 md:grid-cols-2">
              {currentItem?.choices?.map((options, index) => {
                const isSelected = selectedIndex
                  ? selectedIndex.selected == OPTIONS[index]
                  : false;

                return (
                  <>
                    <QuestionOptions
                      key={index + 1}
                      index={index}
                      item={options}
                      isShowAnswer={true}
                      correct={currentItem?.question?.correct_answer}
                      selected={questions[currentIndex]?.selected_choice}
                      isSelected={isSelected}
                      didNotAnswer={false}
                      onPress={() => {}}
                      theme={theme}
                    />
                  </>
                );
              })}
            </div>
            </div>
            {true && (
              <div className="pt-6">
                <AnswerMessage
                    correct_answer={currentItem?.question?.correct_answer}
                    selected_answer={questions[currentIndex]?.selected_choice}
                />
                <ExplanationComponent
                  explanation={currentItem.question?.explanation ?? ""}
                  topic={topic}
                  sub_domain={
                    currentItem?.question?.sub_domain
                      ? currentItem?.question?.sub_domain
                      : ""
                  }
                />
                <RelatedStudyArticles
                  relatedArticles={currentItem?.question?.related_articles}
                  currentQuestion={currentItem}
                  hideBookmark={isOnboarding}
                  isDiagnostic={isOnboarding}
                />
              </div>
            )}
          </div>
          </div>
        ) : (
          ""
        )}
        
        {questions?.length > 0 && (
        
        <NavBar
      type="test"
      onNext={onNext}
      onPrevious={onPrevious}
      currentIndex={currentIndex}
      dataSet={questions.length ?? 0}
      navTitle="Question"
      showEnd={false}
      onEndTest={() => {}}
    />
      
      
    )}

      <TestReviewCommunity
        isOpen={isCommunityPopup}
        type="Question"
        onClose={() => setCommunityPopup(false)}
        communityStats={communitySettings}
        theme={theme}
      />
      

      
    </div>
  );
}

export default QuestionReview;
